import { Injectable } from '@angular/core';
import { AuthGuardService } from '@shared/services/auth-guard.service';

@Injectable()
export class ReduceToClearPermission {
  constructor(protected authGuardService: AuthGuardService) {}

  public get hasViewReduceToClearRequest(): boolean {
    return this.authGuardService.checkPermission(['pm_rtc_req_v']);
  }

  public get hasViewReduceToClear(): boolean {
    return this.authGuardService.checkPermission(['pm_rtc_v']);
  }
}
